module.exports = __webpack_public_path__ + "static/media/touchandtell-logo.270f8f47.png";


//////////////////
// WEBPACK FOOTER
// ./src/layout/App/components/AuthContainer/components/RelayRootContainer/components/IntlContainer/components/RoutesContainer/components/Header/img/touchandtell-logo.png
// module id = 1700
// module chunks = 0